import { FunctionComponent, useMemo, useState } from "react";
import { DataList, DataListColumn, StatusBadge, MoneyValue, SectionTitle } from "../../../../components/ui";
import {formatAssetAmount} from "../../../../utils/decimal";
import PageCard from "../../../../components/ui/PageCard/PageCard";
import { Wallet } from "lucide-react";

type BalanceList = {
    items: Array<any>
}

type BalanceRow = {
    wallet: any;
    amount: any;
    value: any;
    lastAmount: any;
    lastUpdated: any;
    createdAt: any;
}

type BalanceGroup = {
    wallet: any;
    rows: BalanceRow[];
}

const BalanceClientList : FunctionComponent<BalanceList> = ({items}) => {

    const balance: BalanceRow[] = items.map( (item) => {
        return item.balances.map( (balance:any) => {
            return {
                wallet: item.wallet,
                amount: balance.amount,
                value: balance.value,
                lastAmount: balance.last_amount,
                lastUpdated: balance.updated_at,
                createdAt: item.wallet.createdAt,
            }
        })
    }).flat();

    // Agrupa as linhas de saldo por carteira (usando o wallet nickname)
    const balanceGroups: BalanceGroup[] = useMemo(() => {
        const groups = new Map<string, BalanceGroup>();

        balance.forEach((row) => {
            const key = String(row.wallet?.id ?? row.wallet?.nickname ?? "sem-carteira");

            if (!groups.has(key)) {
                groups.set(key, { wallet: row.wallet, rows: [] });
            }

            groups.get(key)!.rows.push(row);
        });

        return Array.from(groups.values());
    }, [balance]);

    const BalanceColumns: DataListColumn<any>[] = [
        {
            key: "amount", header: "Saldo Final", render: (b) => (
                <span className="cell-stack">
                    <strong>{formatAssetAmount(b.amount, b.wallet.asset?.symbol ?? "")} </strong>
                </span>
            ),
        },
        {
            key: "lastUpdated", header: "Ultima atualizacao", render: (b) => (
                <span className="cell-stack">
                    <strong>{b.lastUpdated}</strong>
                </span>
            ),
        },
        {
            key: "value", header: "Ultima transacao", render: (b) => (
                <span className="cell-stack">
                    <strong>
                        <MoneyValue amount={b.value} precision={4} />
                    </strong>
                    <small className="num" style={{fontSize: ".65rem", opacity: 0.55, whiteSpace: "nowrap", display: "flex", overflowWrap: "break-word" }}>Saldo anterior: {formatAssetAmount(b.lastAmount, b.wallet.asset?.symbol ?? 0)}</small>
                </span>
            ),
        },
         {
            key: "date", header: "Data", render: (b) => (
                <span className="cell-stack">
                    <strong>{b.createdAt}</strong>
                </span>
            ),
        },
        
    ]

    return (
         <div className="balance-list-wrapper">
            {balanceGroups.map((group) => (
                <PageCard
                    key={String(group.wallet?.id ?? group.wallet?.nickname)}
                    className="balance-wallet-card"
                >
                    <SectionTitle count={group.rows.length}>
                        <h3>
                            <span className="round">
                                <Wallet size={20}/>
                            </span>
                            {group.wallet?.nickname.toUpperCase() ?? "Carteira sem nome"}
                        </h3>
                    </SectionTitle>

                    <div className="balance-list-header">
                        <DataList
                            columns={BalanceColumns}
                            rows={group.rows}
                        />
                    </div>
                </PageCard>
            ))}
        </div>
    )
}

export default BalanceClientList;